import {
  useMaterialReactTable,
  MaterialReactTable,
} from "material-react-table";
import {
  Box,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
  Button,
  Tooltip,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Header from "../../component/Header";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import EditAboutUs from "./editAbout";
import {
  fetchAboutAction,
  deleteAboutAction,
  updateRowOrderAction,
} from "../../state/aboutus/aboutUsSlice";
import AddAboutUs from "./addAboutUs";

const AboutUs = () => {
  const dispatch = useDispatch();

  const [dataSource, setDataSource] = useState([]);
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const [detailsToDelete, setDetailsToDelete] = useState(null);
  const [toastMessage, setToastMessage] = useState("");
  const [openToast, setOpenToast] = useState(false);

  const [openDrawer, setOpenDrawer] = useState(false);
  const [openEditDrawer, setOpenEditDrawer] = useState(false);
  const [editId, setEditId] = useState(null);

  const aboutUs = useSelector((state) => state.aboutUs.Details);

  const openHandler = () => {
    setOpenDrawer((o) => !o);
  };
  const openEditHandler = () => {
    setOpenEditDrawer((o) => !o);
  };

  const columns = [
    {
      accessorKey: "orderNumber",
      header: "ID",
      size: 50,
    },

    {
      accessorKey: "details",
      header: "Details",
      size: 200,
      Cell: ({ row }) => (
        <Tooltip placement="top-end" title={row.original.details}>
          <span>{row.original.details}</span>
        </Tooltip>
      ),
    },
    {
      accessorKey: "summary",
      header: "Summary",
      size: 100,

      Cell: ({ row }) => (
        <Tooltip placement="top-end" title={row.original.summary}>
          <span> {row.original.summary}</span>
        </Tooltip>
      ),
    },
    {
      header: "Actions",
      Cell: ({ row }) => (
        <span>
          <Tooltip title="Delete">
            <IconButton
              color="error"
              onClick={() => handleConfirmDelete(row.original._id)}
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Edit">
            <IconButton
              color="error"
              onClick={() => handleEditDetails(row.original._id)}
            >
              <EditIcon />
            </IconButton>
          </Tooltip>
        </span>
      ),
    },
  ];
  useEffect(() => {
    dispatch(fetchAboutAction());
  }, [dispatch]);

  useEffect(() => {
    if (aboutUs) {
      const dataa = aboutUs.map((item) => ({ ...item, id: item.id }));
      setDataSource(dataa);
    }
  }, [aboutUs]);
  const handleDeleteDetails = async () => {
    if (detailsToDelete) {
      await dispatch(deleteAboutAction(detailsToDelete));
      setDeleteConfirmationOpen(false);
      await dispatch(fetchAboutAction());
      setToastMessage("Details deleted successfully");
      setOpenToast(true);
    }
  };

  const handleConfirmDelete = (Id) => {
    setDetailsToDelete(Id);
    setDeleteConfirmationOpen(true);
  };

  const handleCloseDeleteConfirmation = () => {
    setDetailsToDelete(null);
    setDeleteConfirmationOpen(false);
  };

  const handleToastClose = () => {
    setOpenToast(false);
  };

  const handleEditDetails = (id) => {
    //navigate(`/dashboard/editAboutUs/${Id}`)
    openEditHandler();
    setEditId(id);
  };

  const handleRowOrderChange = (newData) => {
    // Dispatch the action to update the row order
    dispatch(updateRowOrderAction(newData))
      .then(() => {
        // If the action was successful, update the local state
        setDataSource(newData);
        console.log(newData);
      })
      .catch((error) => {
        console.error("Error updating row order:", error);
        // Handle the error if necessary
        // You might want to show a toast message or handle the error in some other way
      });
  };
  const table = useMaterialReactTable({
    autoResetPageIndex: false,
    columns,
    data: dataSource,
    enableRowOrdering: true,
    enableSorting: true,
    muiRowDragHandleProps: ({ table }) => ({
      onDragEnd: () => {
        const { draggingRow, hoveredRow } = table.getState();
        if (hoveredRow && draggingRow) {
          const newData = [...dataSource];
          newData.splice(
            hoveredRow.index,
            0,
            newData.splice(draggingRow.index, 1)[0]
          );
          handleRowOrderChange(newData);
          setDataSource(newData);
        }
      },
    }),
  });
  return (
    <>
      <Dialog
        open={deleteConfirmationOpen}
        onClose={handleCloseDeleteConfirmation}
        aria-labelledby="delete-confirmation-dialog-title"
      >
        <DialogTitle id="delete-confirmation-dialog-title">
          Confirm Delete
        </DialogTitle>
        <DialogContent>
          Are you sure you want to delete this details?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteConfirmation} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleDeleteDetails} color="secondary">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={openToast}
        autoHideDuration={3000}
        onClose={handleToastClose}
        message={toastMessage}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        key={"bottom-left"}
      />
      <EditAboutUs
        handleClose={openEditHandler}
        open={openEditDrawer}
        id={editId}
      />
      <Box m="1.5rem 2rem">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Header title="About Us" subtitle="List of About Us Details" />
          <Button
            variant="contained"
            onClick={openHandler}
            size="lg"
            color="secondary"
            startIcon={<AddCircleOutlineIcon />}
          >
            Add
          </Button>
          <AddAboutUs handleClose={openHandler} open={openDrawer} />
        </div>

        <Box mt="40px" height="75vh">
          <MaterialReactTable table={table} />
        </Box>
      </Box>
    </>
  );
};

export default AboutUs;
